import { BoxProps } from '@mui/material';
import Box from '@mui/material/Box';
import clsx from 'clsx';

import { tokens } from '../../../theme/generated/tokens';
import { mergeSx } from '../../../utils';
import { classNamesFor } from '../../../utils/classNames';

const classNamesFactory = classNamesFor('Panel');

export const panelClassNames = {
  root: classNamesFactory.root(),
};

export type PanelProps = BoxProps & {
  /** `data-testid` attribute value */
  testId?: string;
};

/**
 * A container with white background, border, and rounded corners.
 * Groups content on LayoutCard.
 */
export const Panel = ({
  children,
  className,
  testId,
  sx,
  ...rest
}: PanelProps) => {
  return (
    <Box
      className={clsx(panelClassNames.root, className)}
      sx={mergeSx(
        {
          backgroundColor: tokens.theme.bg.structural.surface,
          border: `1px solid ${tokens.theme.border.structural.neutral}`,
          borderRadius: tokens.theme.radius.sm,
          overflow: 'clip',
        },
        sx
      )}
      data-testid={testId}
      {...rest}
    >
      {children}
    </Box>
  );
};
